import { MainArc } from "./components/MainArc";
import { CenterReadout } from "./components/CenterReadout";
import { StatusIndicators } from "./components/StatusIndicators";
import { LitersGauge } from "./components/LitersGauge";
import { HealthGauge } from "./components/HealthGauge";
import type { SpeedometerProps } from "./types";

const H = 325;
// Visible content spans x=200..700 within the 900px SVG coordinate space
const VIEW_X = 200;
const VIEW_W = 500;

export function Speedometer({
  speed,
  unit = "KM/H",
  dangerThresholdPct = 0.8,
  liters,
  maxLiters,
  maxSpeed,
  acceleration,
  health,
  maxHealth,
  indicators,
  onHealthMax,
  scale = 1,
  className,
}: SpeedometerProps) {
  return (
    <div className={className} style={{ width: VIEW_W * scale, height: H * scale, overflow: "visible" }}>
    <div
      className="relative purista-font"
      style={{
        width: VIEW_W,
        height: H,
        overflow: "visible",
        transform: `scale(${scale})`,
        transformOrigin: "top left",
      }}
    >
      {/* ── Main SVG ── */}
      <svg
        width={VIEW_W}
        height={H}
        viewBox={`${VIEW_X} 0 ${VIEW_W} ${H}`}
        style={{ position: "absolute", top: 0, left: 0, overflow: "visible" }}
      >
        <LitersGauge liters={liters} maxLiters={maxLiters} />
        <HealthGauge
          health={health}
          maxHealth={maxHealth}
          onHealthMax={onHealthMax}
        />
        <MainArc
          acceleration={acceleration}
          dangerThresholdPct={dangerThresholdPct}
        />
        <CenterReadout speed={speed} unit={unit} maxSpeed={maxSpeed} />
        <StatusIndicators
          seatbelt={indicators.seatbelt}
          airbag={indicators.airbag}
          doors={indicators.doors}
          handbrake={indicators.handbrake}
        />
      </svg>
    </div>
    </div>
  );
}
